import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DEPOSIT_ROUTE,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  LOGIN_ROUTE,
  logout,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RootState,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
  useAppDispatch,
  useAppSelector,
  WITHDRAW_ROUTE,
  UserMenuEnum,
  getUsername,
  notDemoUser,
  getLangData,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  showToast,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/images/Casino_svg_img/User_Icon.svg";
import { headerGradient } from "../../../utils/constants/common.constants";
import MenuComponent from "../shared/MenuComponent";
import NewsAndPromotions from "../shared/NewsAndPromotions";
import HeaderButtonComponent from "./HeaderButtonComponent";
import HeaderSearchInput from "./HeaderSearchInput";
import LoginButtons from "./LoginButtons";
import SubHeader from "./SubHeader";
import Modal from "../shared/ExpModal";
import Button from "../shared/Button/Button";
import Languages from "../user-menu-pages/Languages";
import AllOpenBets from "../user-menu-pages/OpenBets/AllOpenBets";
import SkinOptions from "./SkinOptions";
import SkinIcon from "../../../assets/icons/header-icons/skin-icon.svg";
import { domain } from "../../../constants/Branding";
import { getEnvVariable } from "../../../constants/brandConfig";

function shouldShowSkinSwitcher(lookup: string): boolean {
  const skins = getEnvVariable(lookup, "skins");
  if (!Array.isArray(skins)) return false;
  return skins.filter((s) => !s?.disabled).length >= 1;
}

interface HeaderProps {
  disableSportsSubheader?: boolean;
  balance: number;
  exposure: number;
  loggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({
  disableSportsSubheader,
  balance,
  exposure,
  loggedIn,
}) => {
  const showSkinSwitcher = shouldShowSkinSwitcher(domain);
  const [showOpenBets, setShowOpenBets] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const pathName = useLocation().pathname;
  const [Balance, setBalance] = useState<string | number>(balance);
  const [Exposure, setExposure] = useState<string | number>(exposure);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [langSelected, setLangSelected] = useState<string>();
  const hasInplayInPath = pathName.includes(IN_PLAY_ROUTE);

  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isSkinOpen, setIsSkinOpen] = useState(false);
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const userMenuList = [
    {
      title: UserMenuEnum.MY_PROFILE,
      navigationUrl: MY_PROFILE_ROUTE,
      enabled: true,
    },
    {
      title: "Claim Bonuses",
      navigationUrl: "/bonus_rewards",
      enabled: domainConfig.bonus && notDemoUser(),
    },
    { title: UserMenuEnum.HOME, navigationUrl: HOME_ROUTE },
    {
      title: UserMenuEnum.ACCOUNT_STATEMENT,
      navigationUrl: ACCOUNT_STATEMENT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.PROFIT_LOSS_REPORT,
      navigationUrl: PROFIT_LOSS_REPORT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_WALLET,
      navigationUrl: MY_WALLET_ROUTE,
      enabled: true,
    },
    // {
    //   title: UserMenuEnum.TURNOVER_REPORT,
    //   navigationUrl: TURNOVER_REPORT_ROUTE,
    //   enabled: true,
    // },
    {
      title: UserMenuEnum.AFFILIATE_PROGRAM,
      navigationUrl: AFFILIATE_PROGRAM_ROUTE,
      enabled: domainConfig.affiliate && notDemoUser(),
    },
    {
      title: UserMenuEnum.TURNOVER_REPORT,
      navigationUrl: TURNOVER_REPORT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    {
      title: UserMenuEnum.BONUS_STATEMENT,
      navigationUrl: BONUS_STATEMENT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    // {
    //   title: "deposit_turnover", //add to ui core
    //   navigationUrl: "/deposit-turnover", //add route to ui core
    //   enabled: true,
    // },
    {
      title: "promotions", //add to ui core
      navigationUrl: "/promotions", //add route to ui core
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_TRANSACTION,
      navigationUrl: MY_TRANSACTION_ROUTE,
      enabled: domainConfig.payments && notDemoUser(),
    },
    // {
    //   title: UserMenuEnum.STAKE_SETTINGS,
    //   navigationUrl: STAKE_SETTINGS_ROUTE,
    //   enabled: true,
    // },

    {
      title: UserMenuEnum.MY_BET,
      navigationUrl: MY_BETS_ROUTE,
      enabled: true,
    },
    {
      title: "Change Password",
      navigationUrl: "/change-password",
      enabled: true,
    },
    {
      title: UserMenuEnum.SIGNOUT,
      navigationUrl: LOGIN_ROUTE,
      enabled: true,
    },
  ];
  const { langData } = useAppSelector((state) => state.cms);

  useEffect(() => {
    const selectedLang = sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang")
      : "en";
    dispatch(getLangData(selectedLang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ToggleSkins = () => {
    return (
      <MenuComponent
        menuTitle={<img src={SkinIcon} />}
        menuList={<SkinOptions />}
        isOpen={isSkinOpen}
        closeMenu={() => setIsSkinOpen(false)}
        toggleMenu={() => setIsSkinOpen(!isSkinOpen)}
      />
    );
  };

  const menuList = (
    <ul className="flex flex-col font-helvetica text-[11px]">
      <li className="p-2 text-white text-xs font-bold bg-custom-four-color-gradient">
        {getUsername()}
      </li>
      {userMenuList.map(
        ({ title, navigationUrl, enabled }, index) =>
          enabled && (
            <li
              key={index}
              className={`hover:underline cursor-pointer ${
                title === UserMenuEnum.SIGNOUT ? "" : "border-b border-b-gray18"
              }`}
            >
              {title === UserMenuEnum.SIGNOUT ? (
                <div
                  className="text-center bg-blue4 text-white py-2 font-bold text-xs"
                  onClick={() => {
                    dispatch(logout());
                    dispatch(
                      showToast({
                        type: "success",
                        message: "Logged out successfully",
                      })
                    );
                  }}
                >
                  {langData?.["logout"]}
                </div>
              ) : (
                <div className="px-2 py-1">
                  <Link to={navigationUrl || ""} className="cursor-pointer">
                    {title}
                  </Link>
                </div>
              )}
            </li>
          )
      )}
    </ul>
  );

  const handleWithdrawClick = () => {
    navigate(WITHDRAW_ROUTE);
  };

  const handleDepositClick = () => {
    navigate(DEPOSIT_ROUTE);
  };
  // useEffect(() => {
  //   // console.log('langsel1--->>>')
  //   if(langSelected !== undefined){
  //     // console.log('langsel2--->>>')
  //       sessionStorage.setItem("lang", langSelected);
  //       dispatch(getLangData(langSelected));
  //   }
  // }, [langSelected]);

  return (
    <div
      className={`flex flex-col flex-0 md:gap-[1px] w-full ${
        isMobile && !hasInplayInPath ? "gap-[1px]" : ""
      }`}
    >
      <div
        className={`flex items-center justify-between p-2 md:p-2 ${headerGradient}`}
      >
        <div className="flex md:gap-3 items-center">
          <img
            src={getEnvVariable(domain, "logo")}
            alt="logo"
            className={`md:my-2 lg:my-0 cursor-pointer ${getEnvVariable(domain, "logoClassName") || "h-[28px] md:h-[40px] lg:h-[53px]"}`}
            onClick={() => navigate(`${HOME_ROUTE}`)}
          />

          {loggedIn && (
            <div className="hidden md:block">
              <HeaderSearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </div>
          )}
        </div>

        {loggedIn ? (
          <div className="flex gap-2 md:gap-1 items-center">
            {domainConfig?.payments && domainConfig.b2cEnabled && (
              <div className="flex justify-center">
                {getUsername() !== "Demo User" && (
                  <>
                    <Button
                      onClick={handleDepositClick}
                      className="flex gap-2 text-xs rounded items-center bg-[#008000] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {isMobile ? langData?.["d"] : langData?.["deposit"]}
                      </span>
                    </Button>

                    <Button
                      onClick={handleWithdrawClick}
                      className="flex gap-2 text-xs rounded items-center bg-[#FF0000] py-[2px] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {isMobile ? langData?.["w"] : langData?.["withdraw"]}
                      </span>
                    </Button>
                  </>
                )}
              </div>
            )}
            <div className="flex md:gap-1">
              <div className="flex flex-row-reverse md:gap-1 md:flex-row">
                <HeaderButtonComponent
                  onClick={() => {}}
                  isRedButton={false}
                  customButtonHeight="h-[38px] md:h-[30px]"
                  customButtonRadius="rounded-[5px] md:rounded-[5px]"
                >
                  {isDesktop ? (
                    <div className="flex flex-col md:flex-row gap-0 md:gap-1 items-center text-[11px] text-white font-bold">
                      <div className="flex gap-1 hover:underline">
                        <span className="font-thin text-gray-400 ">Bal </span>
                        {((Number(balance) - Number(exposure)) / cFactor)?.toFixed(2)}
                      </div>
                      <div
                        className="flex gap-1 hover:underline"
                        onClick={() => setShowOpenBets(true)}
                      >
                        <span className="font-thin text-gray-400">Exp</span>
                        {(Number(exposure) / cFactor)?.toFixed(2)}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center bg-gradient-to-b from-blue10  text-white text-[9px] font-bold ">
                      {/* Avatar and Username */}
                      <div className="flex items-center gap-1  ">
                        <img
                          src={UserIcon}
                          alt="avatar"
                          className="w-5 h-5 rounded-full hidden md:block"
                        />
                        <span className="uppercase mr-2">{getUsername()}</span>
                      </div>
                      <span className="h-[2.2rem] border-r-[px] border-blue-500 "></span>
                      {/* Balance */}
                      <div className="flex flex-col">
                        <div className="flex items-center text-[11px] font-[500] gap-1 ">
                          <span className="font-thin text-gray-400">Bal</span>
                          <span>
                            {((Number(balance) - Number(exposure)) / cFactor)?.toFixed(2)}
                          </span>
                        </div>

                        {/* Exposure */}
                        <div
                          className="flex items-center gap-1   cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                        >
                          <span className="font-thin text-gray-400">Exp</span>
                          <span className="text-gray-400">
                            (
                            <span className="text-red-500">
                              {(Number(exposure) / cFactor)?.toFixed(2)}
                            </span>
                            )
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </HeaderButtonComponent>
                <div className="relative hidden md:flex gap-1">
                  <MenuComponent
                    menuList={menuList}
                    menuTitle={getUsername()}
                    customImage={{ imagePosition: "left", imageSrc: UserIcon }}
                    customButtonCss="bg-blue4 text-white text-xs rounded-[5px] h-[30px] px-3"
                    toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                    isOpen={isMenuOpen}
                    closeMenu={closeMenu}
                  />
                  {/* <Languages langSelected={langSelected} setLangSelected={setLangSelected} /> */}
                </div>
                {/* <HeaderButtonComponent
                  onClick={() => {}}
                  leftIcon={{
                    src: UserIcon,
                    alt: "Icon Description",
                    customClassName: "h-3 w-3",
                  }}
                  ButtonText={getUsername()}
                  isRedButton={false}
                  customCSS="border-r border-blue33"
                  customButtonHeight="h-[38px] md:h-[30px]"
                  customButtonRadius="rounded-l-[5px] md:rounded-[5px]"
                /> */}
              </div>

              {showSkinSwitcher ? ToggleSkins() : null}
            </div>
          </div>
        ) : (
          <div className="flex gap-1">
            <LoginButtons />
            <Languages
              langSelected={langSelected}
              setLangSelected={setLangSelected}
            />
          </div>
        )}
      </div>

      {pathName === `${HOME_ROUTE}` && isMobile && (
        <div className="md:hidden">
          <NewsAndPromotions />
        </div>
      )}

      <div className="w-screen overflow-scroll hide-scrollbar bg-black">
        <SubHeader disableSportsSubheader={disableSportsSubheader} />
      </div>
      <Modal
        isOpen={showOpenBets}
        onClose={() => {
          setShowOpenBets(false);
        }}
        title={langData?.["my_market"]}
        modalBg="bg-custom-four-color-gradient"
      >
        <AllOpenBets setShowOpenBets={setShowOpenBets} />
      </Modal>
    </div>
  );
};
export default Header;
